
import angular from 'angular';

export default function SyncAssetController(
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmDialog,
  editAssetDialog,
  editRiskDialog,
  loaderService,
  assetDataService,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
  ssDialogService,
  userService,
  deleteAssetConfirmDialog,
  praDataService,
  syncAssetConfirmDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.asset.hasData = false;
  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.handleSyncAssetChange = _handleSyncAssetChange;
  vm.handleSyncClick = _handleSyncClick;
  _activate();


  function _activate() {
    _initTooltips();
    _initCriticality();
    _initPermissions();
  }

  function _handleSyncAssetChange() {
    $rootScope.$broadcast('selectSyncAssetChange');
  }

  function _initTooltips() {
    if (vm.asset) {
      vm.asset.assetDataTypeTooltip = 'This is ';
      switch (vm.asset.assetDataTypeId) {
        case 1:
          vm.asset.assetDataTypeTooltip += ' a Physical Asset.';
          break;
        case 2:
          vm.asset.assetDataTypeTooltip += ' an Electronic Asset.';
          break;
        case 3:
          vm.asset.assetDataTypeTooltip += ' both a Physical and Electronic Asset. ';
          break;
        default:
          vm.asset.assetDataTypeTooltip = null;
      }
    }
  }

  function _initCriticality() {
    if (vm.asset) {
      const classMappings = {
        1: 'status-tier-bar--terrible',
        2: 'status-tier-bar--bad',
        3: 'status-tier-bar--caution',
        4: 'status-tier-bar--good',
        5: 'status-tier-bar--great',
      };
      vm.asset.criticalityCssClass = classMappings[vm.asset.assetCriticalityId];
      vm.asset.assetCriticality = assetSharedModelService.AssetCriticalities.find(
        assetCriticality => assetCriticality.assetCriticalityId === vm.asset.assetCriticalityId
      );
    }
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleSyncClick($event) {
    vm.asset.showCriticality = false;
    ssDialogService.dialogs.assetAdmin.syncAssetDialog = ssDialogService.alert(
      syncAssetConfirmDialog.getOptions($event, {
        asset: vm.asset,
        assetType: vm.assetType,
        updateCallBack: _broadcastEvents,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.assetAdmin.syncAssetDialog);
  }

  function _broadcastEvents() {
    $rootScope.$broadcast('refreshSyncAssets', { assetType: vm.assetType });
    $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
  }

  function _handleExpandControlClick() {
    if (!vm.asset.hasData) {
      assetDataService.getAsset(vm.asset.customerAssetId).then((getAssetResponse) => {
        angular.merge(vm.asset, getAssetResponse.data);
        vm.asset.customerRisks.forEach((risk) => {
          riskSharedModelService.transformRiskTop(risk);
          risk = riskSharedModelService.addSeverityDescriptionsToRiskType(risk);
          risk = riskSharedModelService.transformMeterStatusToRiskType(risk);
          risk = riskSharedModelService.addColorToProbability(risk);
        });
        vm.asset.hasData = true;
      });
    }
    vm.isExpanded = !vm.isExpanded;
  }
}

SyncAssetController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'editAssetDialog',
  'editRiskDialog',
  'loaderService',
  'assetDataService',
  'riskDataService',
  'assetSharedModelService',
  'riskSharedModelService',
  'ssDialogService',
  'userService',
  'deleteAssetConfirmDialog',
  'praDataService',
  'syncAssetConfirmDialog'
];
